import { Checkbox } from "@mantine/core";
import PropTypes from "prop-types";
import { useDualTranslation } from "../utils/i18nHelpers";

const WeekdaysSelector = ({
  WEEK_DAYS,
  usedWeekdays,
  selectedSeason,
  activeDayGroup,
  handleWeekdayClick,
}) => {
  const { t } = useDualTranslation();

  return (
    // Changed ml-2 to ms-2 for margin-start
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
        {/* Removed form-group class (not needed in BS5), added mb-3 for spacing */}
        <div className="row align-items-center mb-3">
          <label
            htmlFor="form-weekdays" // Changed htmlFor to point to the container id
            // Removed 'bold' class, kept inline style for font weight
            className="mt-2"
            style={{ fontSize: "12px", fontWeight: "700" }}
          >
            {t("tariff.weekdays.selectYourDays", {
              name: selectedSeason?.periods[activeDayGroup]?.dayGroupName,
            })}
          </label>

          {/* Added col-sm-9 directly here for BS5 grid structure */}
          <div
            className="col-sm-9 d-flex flex-row justify-content-around mt-2"
            id="form-weekdays"
            style={{ maxWidth: "400px" }}
          >
            {WEEK_DAYS.map((day) => (
              <Checkbox
                key={day.id}
                label={<span className="font-10px line-spacing">{day.name}</span>}
                checked={!!selectedSeason?.periods?.[activeDayGroup]?.weekDays?.includes(day.id)}
                disabled={usedWeekdays?.has(day.id)}
                onChange={() => !usedWeekdays?.has(day.id) && handleWeekdayClick(day.id)}
                size="lg"
                color="green"
                className={`display-weekdays pointer ${usedWeekdays?.has(day.id) ? "pe-none diabled-avoid" : ""}`}
                styles={{
                  body: { flexDirection: "column-reverse", alignItems: "center" },
                  label: { paddingLeft: "1px", marginBottom: "6px" },
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
WeekdaysSelector.propTypes = {
  WEEK_DAYS: PropTypes.array,
  usedWeekdays: PropTypes.object,
  selectedSeason: PropTypes.object,
  activeDayGroup: PropTypes.number,
  handleWeekdayClick: PropTypes.func,
};

export default WeekdaysSelector;
